import produce from 'immer';

const INITIAL_STATE = {
  registry: null,
  loading: false,
  error: false
};

export default function projectDashboard(state = INITIAL_STATE, action) {
  switch (action.type) {
    case '@projectDashboard/INDEX_REQUEST':
      return produce(state, draft => {
        draft.loading = true;
        draft.error = false;
      });

    case '@projectDashboard/INDEX_SUCCESS':
      return produce(state, draft => {
        draft.loading = false;
        draft.registry = action.payload.data;
      });

    case '@projectDashboard/INDEX_FAILURE':
      return produce(state, draft => {
        draft.loading = false;
        draft.error = true;
      });

    default:
      return state;
  }
}
